// @flow
import type {StoreState} from "../../../reducers/combinedReducers";
import type {
    EBadgeActionButtonDispatchProps,
    EBadgeActionButtonOwnProps,
    EBadgeActionButtonStateProps
} from "../../../components/ebadge/EBadgeActionButton";
import EBadgeActionButton from "../../../components/ebadge/EBadgeActionButton";
import {extractCaller} from "../../QueryPage";
import {Dispatch} from "redux";
import type {Caller} from "../../../components/QueryPage";
import {connect} from "react-redux";
import {openDeleteEBadgePhotoModalAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";

function getIsLoadingStatus(state, registrationCode) {
    let status = state.photoEBadgeAction.del[registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

function mapStateToProps(state: StoreState, ownProps: EBadgeActionButtonOwnProps): EBadgeActionButtonStateProps {

    const registrationCode = ownProps.registrationCode;
    const isLoading = getIsLoadingStatus(state, registrationCode);

    return {
        isLoading,
        caller: extractCaller(state),
        roleIds: state.loginUser.roleIds
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: EBadgeActionButtonOwnProps): EBadgeActionButtonDispatchProps {
    return {

        onClick: (registrationCode: string, unlockCount: number, caller: Caller, roleIds: Array<string>) => {
            // dispatch(photoEBadgeDeleteAction(registrationCode, caller));
            dispatch(openDeleteEBadgePhotoModalAction(registrationCode));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EBadgeActionButton);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/DeleteEBadgePhotoButton.js